import { useContext, useState } from 'react';
import StandardizedDataTable from '../../PrimeAids/StandardizedDataTable';
import { ReportContext } from '../../../context/ReportContext';
import ReportChartLayoutWrapper from '../../PlotlyAids/ReportChartLayoutWrapper';
import ReportLineChart from '../../PlotlyAids/ReportLineChart';
import { dataRollUp } from '../../PlotlyAids/dataRollUps';
import { formatDateToIsoExtDate, userColumns } from '../../../helpers';
import ExpandableInfoCard, {
    ExpandableInfoCardDescription,
    ExpandableInfoCardDetail,
} from '../../Cards/ExpandableInfoCard';

export const userCheckupsColumns = [
    {
        field: 'title',
        name: 'Checkup',
        dataType: 'multiselect',
        styles: { minWidth: '26rem' },
    },
    { field: 'startDatetime', name: 'Start Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'finishDatetime', name: 'Finish Date ({tz} time zone)', dataType: 'datetime' },
    { field: 'completionStatus', name: 'Completed', dataType: 'multiselect' },
];

const UserCheckups = () => {
    const { reportData } = useContext(ReportContext);

    const columns = [...userColumns, ...userCheckupsColumns];

    const [filteredData, setFilteredData] = useState([]);

    // const rolledUp = dataRollUp(
    //     filteredData,
    //     (row) => formatDateToIsoExtDate(row.startDatetime),
    //     {
    //         count: true,
    //     }
    // );

    // const chartData = [
    //     {
    //         name: 'Total Checkups',
    //         x: rolledUp.map((x) => x.groupByField),
    //         y: rolledUp.map((x) => x.count),
    //     },
    // ];

    return (
        <div className="space-y-6">
            <StandardizedDataTable
                data={reportData}
                columns={columns}
                onValueChange={setFilteredData}
            />
            {/* <ReportChartLayoutWrapper>
                <ReportLineChart data={chartData} chartTitle="User Checkups Over Time" />
            </ReportChartLayoutWrapper> */}

            <ExpandableInfoCard title="What is this data?">
                <ExpandableInfoCardDescription>
                    This report shows detailed information about user checkups, including
                    when they were started, completed, and their completion status.
                </ExpandableInfoCardDescription>
                <ExpandableInfoCardDetail name="Checkup">
                    The type of the checkup assessment.{' '}
                    <span className="italic">Initial</span> refers to the onboarding
                    checkup the user is presented with on their initial registration and{' '}
                    <span className="italic">Subsequent</span> refers to any checkup they
                    took after.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Start Date">
                    When the user initiated the checkup.
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Finish Date">
                    When the user completed the checkup (if applicable).
                </ExpandableInfoCardDetail>
                <ExpandableInfoCardDetail name="Completed">
                    The completion status of the checkup, indicating whether it was fully
                    finished.
                </ExpandableInfoCardDetail>
            </ExpandableInfoCard>
        </div>
    );
};

export default UserCheckups;
